export const SET_HEADER_REF = 'refs/SET_HEADER_REF';
export const SET_HEADER_HEIGHT = 'refs/SET_HEADER_HEIGHT';
export const SET_FILTERS_BAR_HEIGHT = 'refs/SET_FILTERS_BAR_HEIGHT';
export const SET_THIRD_PARTY_HEADER_HEIGHT = 'refs/SET_THIRD_PARTY_HEADER_HEIGHT';
export const SET_FILTERS_LIST_MENU_HEIGHT = 'refs/SET_FILTERS_LIST_MENU_HEIGHT';
export const SET_TRAVEL_SUMMARY_BAR_HEIGHT = 'refs/SET_TRAVEL_SUMMARY_BAR_HEIGHT';
export const SET_VIRTUOSO_REF = 'refs/SET_VIRTUOSO_REF';
